<nav class="navbar navbar-dark">
    <div class="container">
        <span class="navbar-brand mb-0">Adventskalender</span>
        <ul class="navbar-nav ml-auto">
            <li class="nav-item badge">
                {{heutigesDatum()}}
            </li>
        </ul>
    </div>
</nav>

<div class="container">
    <div id="vorwort-einleitung" class="row">
        <!-- <ngb-alert class="text-center" [dismissible]="false">
            Der Adventskalender ist noch bis einschließlich <strong>6. Januar 2021</strong> verfügbar und wird danach offline geschaltet.
          </ngb-alert> -->
        <button routerLink="/vorwort" [state]="{tag: vorwort}" class="btn">Vorwort</button>
        <button routerLink="/einleitung" [state]="{tag: einleitung}" class="btn">Einleitung</button>
    </div>
    <div *ngIf="getDataService.liste !== null" class="row">
        <div *ngFor="let tag of getDataService.liste" class="col-6 col-md-4 col-lg-2 my-2">
            <button *ngIf="checkDatum(tag.id) == true" routerLink="/{{tag.id}}" [state]="{tag: tag}"
                class="open btn btn-block">{{tag.id}}</button>
            <button *ngIf="checkDatum(tag.id) != true" class="closed btn btn-block">{{tag.id}}</button>
        </div>
    </div>
</div>